'use client'

import { useParams } from 'next/navigation'
import dynamic from 'next/dynamic'
import { Skeleton } from '@/components/ui/skeleton'

// Loading skeleton for fullscreen pages
function PageSkeleton() {
    return (
        <div className="w-full min-h-full p-6 mb-50">
            <div className="space-y-6">
                <Skeleton className="h-10 w-48" />
                <Skeleton className="h-[400px] w-full" />
            </div>
        </div>
    )
}

// Dynamically import all dashboard pages to reduce initial bundle size
const EarningsPage = dynamic(() => import('@/components/dashboard/earnings/earnings-page'), {
    ssr: false,
    loading: () => <PageSkeleton />,
})

const EarningsTranscriptPage = dynamic(
    () => import('@/components/dashboard/earnings-transcript/earnings-transcript-page'),
    {
        ssr: false,
        loading: () => <PageSkeleton />,
    }
)

const FilingsPage = dynamic(() => import('@/components/dashboard/filings/filings-page'), {
    ssr: false,
    loading: () => <PageSkeleton />,
})

const GainersLosersPage = dynamic(
    () => import('@/components/dashboard/gainers-losers/gainers-losers-page'),
    {
        ssr: false,
        loading: () => <PageSkeleton />,
    }
)

const InsiderTradesPage = dynamic(
    () => import('@/components/dashboard/insider-trades/insider-trades-page'),
    {
        ssr: false,
        loading: () => <PageSkeleton />,
    }
)

type PageType =
    | 'earnings'
    | 'earnings-transcript'
    | 'sec-filings'
    | 'gainers-losers'
    | 'insider-trades'

export function SlugPageClient() {
    const params = useParams()
    const slug = (params['slug'] as PageType) || null

    if (!slug) return null

    return (
        <div className="w-full min-h-full p-6 mb-50">
            {slug === 'earnings' && <EarningsPage />}
            {slug === 'earnings-transcript' && <EarningsTranscriptPage />}
            {slug === 'sec-filings' && <FilingsPage />}
            {slug === 'gainers-losers' && <GainersLosersPage />}
            {slug === 'insider-trades' && <InsiderTradesPage />}
        </div>
    )
}
